import planItemModalStore from './PlanItemModalStore';
import React from "react";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";

class ErrorMessageFactory {
    generateLink = (errorCode, planItem, analyticsData) => {
        analyticsData.context ="RegView-link";

        const onMoveCourse = () => {
            planItemModalStore.openModal('move', planItem, analyticsData);
        };

        const onAddEditSections = () => {
            planItemModalStore.openModal('update', planItem, {context: "RegView-link"});
        };

        const errorMessageMap = {
            SELECT_SECTIONS : {
                fnc: onAddEditSections,
                msg: "View and select course sections."
            },
            SELECT_REQUIRED_SECTIONS : {
                fnc: onAddEditSections,
                msg: "Select one in order to be able to register for this course."
            },
            MOVE_COURSE : {
                fnc: onMoveCourse,
                msg: "Move it to a future quarter of your plan."
            },
            REMOVE_EDIT_SECTION : {
                fnc: onAddEditSections,
                msg: "Remove or edit course sections."
            },
            REMOVE_ALL_BUT_ONE_SECTION : {
                fnc: onAddEditSections,
                msg: "Remove all but one in order to be able to register for this course."
            },
            SELECT_MULT_REQUIRED_SECTIONS : {
                fnc: onAddEditSections,
                msg: "Select one of each in order to be able to register for this course."
            },
            REMOVE_ALL_BUT_ONE_REQUIRED_SECTION : {
                fnc: onAddEditSections,
                msg: "Remove all but one of each in order to be able to register for this course."
            },
            REMOVE_ALL_BUT_ONE_SECONDARY_SECTION :{
                fnc: onAddEditSections,
                msg: "Remove all but one in order to be able to register for this course."
            },
            REMOVE_ALL_BUT_ONE_OF_EACH_SECONDARY_SECTION: {
                fnc: onAddEditSections,
                msg: "Remove all but one of each in order to be able to register for this course."
            },
            CHECK_WITH_DEPARTMENT : {
                fnc: onAddEditSections,
                msg: "Check with your department and then remove any that don't allow duplicate enrollment in order to be able to register for this course."
            }
        };

        let component = <></>;
        if (errorMessageMap[errorCode] !== undefined) {
            component =
                <button type="button"
                        className="btn btn-inline-link"
                        onClick={errorMessageMap[errorCode].fnc}
                        disabled={appStore.isAdviser()}>
                    {errorMessageMap[errorCode].msg}
                </button>
        }
        return component;
    };
}

export default new ErrorMessageFactory();